const NAVIGATION_MENU_SLOT_CONFIG = {
  header: {
    title: 'Header',
    aliases: ['Header Menu'],
  },
  footer: {
    title: 'Footer',
    aliases: ['Footer Links', 'Legal Links'],
  },
} as const;

export type NavigationMenuSlot = keyof typeof NAVIGATION_MENU_SLOT_CONFIG;

function normalizeNavigationToken(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

export function getNavigationMenuCanonicalTitle(slot: NavigationMenuSlot): string {
  return NAVIGATION_MENU_SLOT_CONFIG[slot].title;
}

export function getNavigationMenuTitles(slot: NavigationMenuSlot): string[] {
  const config = NAVIGATION_MENU_SLOT_CONFIG[slot];
  return [config.title, ...config.aliases];
}

export function isNavigationMenuSlot(value: string): value is NavigationMenuSlot {
  return value in NAVIGATION_MENU_SLOT_CONFIG;
}

export function resolveNavigationMenuSlot(value: string | null | undefined): NavigationMenuSlot | null {
  if (!value) return null;

  const normalizedValue = normalizeNavigationToken(value);
  for (const slot of Object.keys(NAVIGATION_MENU_SLOT_CONFIG) as NavigationMenuSlot[]) {
    const candidates = [slot, ...getNavigationMenuTitles(slot)];
    if (candidates.some((candidate) => normalizeNavigationToken(candidate) === normalizedValue)) {
      return slot;
    }
  }

  return null;
}

export function isSystemNavigationMenuTitle(value: string | null | undefined): boolean {
  return resolveNavigationMenuSlot(value) !== null;
}

export const NAVIGATION_MENU_SLOTS = Object.keys(NAVIGATION_MENU_SLOT_CONFIG) as NavigationMenuSlot[];
